import React, { Component } from 'react';
import * as axios from 'axios';


export class PracticeList extends Component {
  constructor(props) {
    super(props);
    this.state = {practices: []};
  }

  componentDidMount() {
    const params = { 'filter[category_name]': 'practice'};
    axios.get('//midori-frauen.com/wp-json/posts', {params: params})
      .then(resp => {
        this.setState({practices: resp.data});
      });
  }

  render() {
    const PracticeNode = this.state.practices.map((practice, i) => {
      return (
        <div className="practice clearfix" key={i}>
          <span className="practice-date">{practice.meta.news_date}</span>
          <span className="practice-place">{practice.title}</span>
        </div>
      )
    });

    return (
      <div className="practice-list">{PracticeNode}</div>
    )
  }
}

export class SelfPracticeList extends Component {
  constructor(props) {
    super(props);
    this.state = {selfPractices: []};


  }

  componentDidMount() {
    const params = { 'filter[category_name]': 'self-practice'};
    axios.get('//midori-frauen.com/wp-json/posts', {params: params})
      .then(resp => {
        this.setState({selfPractices: resp.data});
      });
  }

  render() {
    const PracticeNode = this.state.selfPractices.map((practice, i) => {
      return (
        <div className="practice clearfix" key={i}>
          <span className="practice-date">{practice.meta.news_date}</span>
          <span className="practice-place">{practice.title}</span>
        </div>
      )
    });

    return (
      <div className="practice-list">{PracticeNode}</div>
    )
  }

}

export class Recruit extends Component {

  constructor(props) {
    super(props);
    this.stats = {practice_content: ''}
  }

  componentDidMount() {
    axios.get('//midori-frauen.com/wp-json/posts/634')
      .then(resp => {
        this.setState({
          practice_content: resp.data
        });
      })
  }

  render() {
    return (
      <div className="content">
        <h2>ご一緒に歌いませんか？</h2>
        <p>
          緑フラウエンコールではメンバーを募集しています。一緒に合唱の素晴らしさを楽しみましょう。
        </p>
        <ul>
          <li>松村努先生の魅力あふれる指導により、美しい響きと聴いてくださる方々の心に届く素敵な演奏をめざします</li>
          <li>斎藤三和子先生の楽しくて元気な気持ちになれるヴォイス・トレーニングにより、発声の基礎も身につけられます</li>
        </ul>

        <h3>練習について</h3>
        <div className='practice-info-wrapper'>
          <dl>
            <dt>練習日時</dt>
            <dd>毎週月曜日 13:00～16:30　（曜日変更の時もあります）</dd>
            <dt>練習会場</dt>
            <dd>アートフォーラムあざみ野（東急田園都市線あざみ野駅近く）など</dd>
            <dt>主な活動</dt>
            <dd>二年毎に演奏会を開催しています。「全日本おかあさんコーラス」、「神奈川県合唱コンクール」等に出場しています。
              その他、「ヨコハマ・コーラルフェスト」等にも出演しています。
            </dd>
            <dt>近日の見学できる練習日程</dt>
            <dd>
              <PracticeList/>
              <div className="practice-detail">
                <h4>練習内容</h4>
                {this.state && this.state.practice_content ?
                  <div dangerouslySetInnerHTML={{__html: this.state.practice_content.content}}/>
                  :
                  null}
              </div>
              <div style={{marginTop: '1rem'}}>
              見学者用の楽譜を用意いたしますので、あらかじめ連絡をお願いいたします
              </div>
            </dd>
            <dt>公開自主練習日</dt>
            <dd>
              <SelfPracticeList/>
            </dd>
          </dl>
        </div>
        <ul>
          <li>60歳位までの方を希望しています</li>
        </ul>
        <h3>ご連絡はこちらから</h3>
        <div>
          Emailアドレス <a href="mailto:midorifrauenchor@gmail.com">midorifrauenchor@gmail.com</a><br/>
          TEL 045-931-8437  (山下)
        </div>
      </div>
    )
  }


}



// WEBPACK FOOTER //
// ./src/components/Recruit.jsx